import { Helpers } from '../../helpers';
import { ICapitalOperationalExpenditure } from '../../interfaces/icapital-operational-expenditure';
import { BudgetCategory } from '../budget-category';
import { Project } from '../project';

export class CapitalOperationalExpenditureBase {
  CapitalOperationalExpenditureId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  BudgetCategories_CapitalOperationalExpenditure?: Array<BudgetCategory> | null;
  Projects_CapitalOperationalExpendature?: Array<Project> | null;

  constructor(item?: ICapitalOperationalExpenditure) {
    if (item) {

      this.CapitalOperationalExpenditureId = item.CapitalOperationalExpenditureId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.BudgetCategories_CapitalOperationalExpenditure = Helpers.createClassArray(BudgetCategory, item.BudgetCategories_CapitalOperationalExpenditure);
      this.Projects_CapitalOperationalExpendature = Helpers.createClassArray(Project, item.Projects_CapitalOperationalExpendature);
    }
  }
}